
import { useCollections } from "@/contexts/collections";
import { useContentForm } from "@/hooks/useContentForm";
import ContentFormFields from "./content-form/ContentFormFields";
import ContentFormActions from "./content-form/ContentFormActions";

export interface ContentFormProps {
  onComplete?: () => void;
  initialData?: {
    id?: string;
    title?: string;
    url?: string;
    description?: string;
    content_type?: string;
    collection_id?: string;
    archived?: boolean;
  };
  isUpdate?: boolean;
}

const BaseContentForm = ({ 
  onComplete, 
  initialData = {}, 
  isUpdate = false 
}: ContentFormProps) => {
  const { collections } = useCollections();
  const { formState, setters, handleSubmit, handleTagToggle } = useContentForm({
    onComplete,
    initialData,
    isUpdate
  });

  return (
    <form onSubmit={handleSubmit} className="space-y-6 py-4">
      <ContentFormFields
        {...formState}
        {...setters}
        collections={collections}
        onTagToggle={handleTagToggle}
      />
      <ContentFormActions
        onComplete={onComplete}
        isSubmitting={formState.isSubmitting}
        isUpdate={isUpdate}
      />
    </form>
  );
};

export default BaseContentForm;
